if (!customElements.get('pawfolio-portrait-tabs')) {
 customElements.define('pawfolio-portrait-tabs', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort(); this.controller = new AbortController();
   const tabs = [...this.querySelectorAll('[data-format]')];
   this.querySelector('.pf-format-tabs').setAttribute('role', 'tablist');
   const select = (tab, focus = false) => tabs.forEach(button => {
    const selected = button === tab; button.setAttribute('role', 'tab'); button.setAttribute('aria-selected', String(selected)); button.tabIndex = selected ? 0 : -1;
    const panel = this.querySelector('#' + button.getAttribute('aria-controls')); panel.setAttribute('role', 'tabpanel'); panel.hidden = !selected;
    if (selected && focus) button.focus();
   });
   tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => select(tab), { signal: this.controller.signal });
    tab.addEventListener('keydown', event => {
     let target; if (event.key === 'ArrowRight') target = (index + 1) % tabs.length; if (event.key === 'ArrowLeft') target = (index + tabs.length - 1) % tabs.length; if (event.key === 'Home') target = 0; if (event.key === 'End') target = tabs.length - 1;
     if (target !== undefined) { event.preventDefault(); select(tabs[target], true); }
    }, { signal: this.controller.signal });
   }); select(tabs[0]);
  }
  disconnectedCallback() { this.controller?.abort(); }
 });
}

if (!customElements.get('pawfolio-detail-gallery')) {
 customElements.define('pawfolio-detail-gallery', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort(); this.controller = new AbortController();
   const track = this.querySelector('.pf-detail-track'), slides = [...track.children], status = this.querySelector('[aria-live]');
   const index = () => Math.round(track.scrollLeft / track.clientWidth);
   const move = step => track.scrollTo({left: ((index() + step + slides.length) % slides.length) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
   this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => move(Number(button.dataset.step)), {signal: this.controller.signal}));
   track.addEventListener('scroll', () => {status.textContent = (index() + 1) + ' / ' + slides.length;}, {passive: true, signal: this.controller.signal});
   track.addEventListener('keydown', event => {if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);}}, {signal: this.controller.signal});
  }
  disconnectedCallback() {this.controller?.abort();}
 });
}

// Mobile category gestures: free dragging with frame-based updates and momentum.
document.querySelectorAll('.pf-gift-categories .pet-ideas-grid').forEach(track => {
 const mobile = matchMedia('(max-width: 640px)');
 let frame = 0, startX = 0, startY = 0, startScroll = 0, position = 0;
 let lastX = 0, lastTime = 0, velocity = 0, axis = '', dragged = false;
 const limit = value => Math.max(0, Math.min(track.scrollWidth - track.clientWidth, value));
 const stop = () => { cancelAnimationFrame(frame); frame = 0; };
 track.addEventListener('touchstart', event => {
  if (!mobile.matches) return;
  stop(); axis = ''; dragged = false; velocity = 0;
  if (event.touches.length !== 1) { axis = 'vertical'; return; }
  startX = lastX = event.touches[0].clientX;
  startY = event.touches[0].clientY;
  startScroll = position = track.scrollLeft;
  lastTime = performance.now();
 }, {passive: true, capture: true});
 track.addEventListener('touchmove', event => {
  if (!mobile.matches || event.touches.length !== 1 || axis === 'vertical') return;
  const x = event.touches[0].clientX, dx = x - startX, dy = event.touches[0].clientY - startY;
  if (!axis) {
   if (Math.max(Math.abs(dx), Math.abs(dy)) < 6) return;
   axis = Math.abs(dx) > Math.abs(dy) ? 'horizontal' : 'vertical';
  }
  if (axis !== 'horizontal') return;
  if (event.cancelable) event.preventDefault();
  dragged = true;
  const now = performance.now(), elapsed = Math.max(1, now - lastTime);
  velocity = velocity * 0.35 + ((lastX - x) / elapsed) * 0.65;
  lastX = x; lastTime = now;
  position = limit(startScroll - dx);
  if (!frame) frame = requestAnimationFrame(() => { track.scrollLeft = position; frame = 0; });
 }, {passive: false, capture: true});
 track.addEventListener('touchend', () => {
  if (!mobile.matches || axis !== 'horizontal') return;
  stop(); track.scrollLeft = position;
  if (performance.now() - lastTime > 100 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  velocity = Math.max(-2, Math.min(2, velocity));
  let previous = performance.now();
  const coast = now => {
   const elapsed = Math.min(32, now - previous); previous = now;
   const next = limit(position + velocity * elapsed);
   if (!mobile.matches || Math.abs(velocity) < 0.02 || next === position) { frame = 0; return; }
   position = next; track.scrollLeft = position;
   velocity *= Math.exp(-elapsed / 180);
   frame = requestAnimationFrame(coast);
  };
  frame = requestAnimationFrame(coast);
 }, {passive: true});
 track.addEventListener('touchcancel', () => { stop(); axis = ''; velocity = 0; }, {passive: true});
 track.addEventListener('click', event => {
  if (mobile.matches && dragged) { event.preventDefault(); event.stopPropagation(); dragged = false; }
 }, true);
});
